import React from "react";
import MainLayout from "./MainLayout";

const TermsOfService = () => {
  return (
    <MainLayout>
      <div className="sv-container">
        <div className="other-card">
          <h2 className="other-header">Terms & Conditions</h2>

          <div className="svp-card-content scrollable">
            <h3>1. Eligibility and Authorised Use</h3>
            <p>
              The TMS is for authorised employees and approved stakeholders of
              Raychem RPG. Unauthorised access, misuse, or circumvention of
              controls is prohibited.
            </p>

            <h3>2. User Responsibilities</h3>
            <p>
              You must keep credentials confidential; provide accurate
              information; refrain from uploading unlawful, harmful, or
              infringing content; and comply with all applicable policies and
              laws.
            </p>

            <h3>3. Intellectual Property</h3>
            <p>
              All training materials, software, and content in the TMS are owned
              by or licensed to Raychem RPG and are protected by applicable law.
              You may not copy, distribute, modify, or create derivative works
              without prior written permission.
            </p>

            <h3>4. Privacy and Data Protection</h3>
            <p>
              Use of the TMS is subject to the Privacy Policy (Part A). You must
              not upload personal data of others without a lawful basis or
              consent commensurate with the DPDP framework.
            </p>

            <h3>5. Availability and Maintenance</h3>
            <p>
              While we strive for high availability, service may be interrupted
              for maintenance or due to events beyond our reasonable control.
            </p>

            <h3>6. Security</h3>
            <p>
              You agree not to probe, scan, or test vulnerabilities or violate
              security or authentication measures. Security incidents must be
              reported promptly via emailing the Grievance Officer.
            </p>

            <h3>7. Termination</h3>
            <p>
              We may suspend or terminate access for policy violations, security
              risks, or upon end of engagement. Upon termination, we may retain
              or delete data in accordance with the Privacy Policy and legal
              requirements.
            </p>

            <h3>8. Disclaimers and Limitation of Liability</h3>
            <p>
              To the extent permitted by law, Raychem RPG is not liable for
              indirect, incidental, or consequential damages arising from TMS
              use. Nothing excludes liability required by applicable law.
            </p>

            <h3>9. Governing Law and Dispute Resolution</h3>
            <p>
              These Terms are governed by the laws of India. Courts with
              appropriate jurisdiction in Mumbai shall have jurisdiction,
              subject to applicable law.
            </p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default TermsOfService;
